import { render } from "./Separator.vue?vue&type=template&id=0b333e53&scoped=true&lang=pug"
import script from "./Separator.vue?vue&type=script&lang=js"
export * from "./Separator.vue?vue&type=script&lang=js"

import "./Separator.vue?vue&type=style&index=0&id=0b333e53&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b333e53"]])

export default __exports__